import { Chip, Stack, TextField } from "@mui/material";
import TableComponent from "./Table";
import { DatePicker } from "@mui/x-date-pickers";
import React, { useEffect, useState } from "react";
import useGetAllReversal from "../../hooks/reversal/useGetAllReversal";
import AutoCompleteCustom from "../../components/AutoCompleteCustom";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import { Search, SupportAgent } from "@mui/icons-material";
import ButtonCustom from "../../components/ButtonCustom";
import LoadingButton from "@mui/lab/LoadingButton";
import { useGridApiRef } from "@mui/x-data-grid";
import { useReversalService } from "../../service/reversal";
import dayjs, { Dayjs } from "dayjs";
import { CustomCircularProgressFullScreen } from "../../components/CustomCircularProgress";
import { useNotificationSnackbar } from "../../hooks/useNotificationSnackbar";

interface IFilter {
  numeroDoPedido: string;
  nome: string | null;
  idCase: number | null;
  loja: string | null;
  dataInicialForm: Dayjs | null;
  dataFinalForm: Dayjs | null;
  statusEstorno: string;
  loginUser: string | null;
  page: number;
  pageSize: number;
  export: boolean;
  [key: string]: string | number | Dayjs | boolean | null;
}

function ReversalPage() {
  const navigate = useNavigate();
  const loginUser = localStorage.getItem("Login");
  const filterInit: IFilter = {
    numeroDoPedido: "",
    nome: null,
    idCase: null,
    loja: null,
    dataInicialForm: dayjs().subtract(1, "day").startOf("day"),
    dataFinalForm: dayjs().endOf("day"),
    statusEstorno: "Pendente",
    loginUser: loginUser,
    page: 0,
    pageSize: 10,
    export: false,
  };
  const [filter, setFilter] = useState<IFilter>(filterInit);

  const { data, isLoading, refresh } = useGetAllReversal(filter);
  const [loading, setLoading] = useState<boolean>(isLoading);
  const profileUser = localStorage.getItem("profile");
  const [rowCountState, setRowCountState] = useState<number>(0);

  useEffect(() => {
    if (data.length > 0) {
      setRowCountState(data[0].totalRows);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10,
  });

  useEffect(() => {
    filter.page = paginationModel.page;
    filter.pageSize = paginationModel.pageSize;
    setFilter(filter);
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationModel]);

  const filterApi = () => {
    setLoading(true);
    setPaginationModel({
      page: 0,
      pageSize: 10,
    });
    setRowCountState(0);
    setLoading(false);
  };

  const gridApiRef = useGridApiRef();
  const { getReversal } = useReversalService();
  const { onErrorSnackbar } = useNotificationSnackbar();

  const handleExport = async (event: any) => {
    event.stopPropagation();
    const fieldsToExport = localStorage.getItem("selectedFields");
    const storedFieldsArray = fieldsToExport ? fieldsToExport.split(",") : [];

    if (storedFieldsArray.length === 0) {
      onErrorSnackbar("Selecione Um Filtro para Exportar");
      return;
    }
    setLoading(true);
    try {
      filter.export = true;
      const response = await getReversal(filter);
      if (response?.status === 200) {
        gridApiRef.current.setRows(response.data);
        gridApiRef.current.exportDataAsCsv({
          fileName: `ExportData-${dayjs().format("DD-MM-YYYY-HH-mm")}`,
          delimiter: ";",
          utf8WithBom: true,
          fields: storedFieldsArray,
        });
        window.location.reload();
      } else {
        console.error("Error al obtener los datos para exportar");
      }
    } catch (error) {
      console.error(
        "Error al realizar la solicitud para obtener los datos para exportar:",
        error
      );
    } finally {
      setLoading(false);
    }
  };

  const dataEstorno = [
    {
      label: "Pendente",
      id: "Pendente",
    },
    {
      label: "Estornado",
      id: "Sim",
    },
    {
      label: "Não estornado",
      id: "Não",
    },
  ];

  const [filterSelected, setFilterSelected] = useState<string | null>(null);

  const filterList = [
    {
      id: "nome",
      name: "Nome Completo",
    },
    {
      id: "numeroDoPedido",
      name: "Número do Pedido",
    },
    {
      id: "idCase",
      name: "Id do Formulário",
    },
    {
      id: "loja",
      name: "Loja",
    },
  ];

  return (
    <Grid container spacing={2}>
      {loading && <CustomCircularProgressFullScreen />}
      <Grid xs={12} md={12} lg={12} xl={12}>
        <Chip icon={<SupportAgent color="error" />} label={"Estorno"} />
      </Grid>
      <Grid
        xs={12}
        md={filterSelected ? 6 : 12}
        lg={filterSelected ? 6 : 12}
        xl={filterSelected ? 6 : 12}
      >
        <AutoCompleteCustom
          title="Filtros"
          options={filterList}
          value={filterSelected}
          onChange={(value) => {
            setFilterSelected(value);
            setFilter((prevState) => ({
              ...prevState,
              [value ?? ""]: "",
              [filterSelected ?? ""]: "",
            }));
          }}
          variant="filled"
        />
      </Grid>
      {filterSelected && (
        <Grid xs={12} md={6} lg={6} xl={6}>
          <TextField
            fullWidth
            variant="filled"
            label={filterList.find((f) => f.id === filterSelected)?.name}
            value={filter[filterSelected ?? ""] ?? ""}
            onChange={(e) =>
              setFilter((prevState) => ({
                ...prevState,
                [filterSelected ?? ""]: e.target.value,
              }))
            }
            disabled={isLoading}
          />
        </Grid>
      )}

      {!filterSelected && (
        <React.Fragment>
          <Grid xs={6} md={6} lg={4} xl={4}>
            <DatePicker
              value={filter.dataInicialForm}
              disabled={!!filter.numeroDoPedido || isLoading}
              onChange={(e: any) =>
                setFilter((prevState) => ({
                  ...prevState,
                  dataInicialForm: e,
                }))
              }
              label="Data inicial do formulário"
              localeText={{
                toolbarTitle: "Data inicial do formulário",
                cancelButtonLabel: "Cancelar",
              }}
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  fullWidth: true,
                  variant: "filled",
                },
              }}
            />
          </Grid>
          <Grid xs={6} md={6} lg={4} xl={4}>
            <DatePicker
              value={filter.dataFinalForm}
              disabled={!!filter.numeroDoPedido || isLoading}
              onChange={(e: any) =>
                setFilter((prevState) => ({
                  ...prevState,
                  dataFinalForm: e,
                }))
              }
              label="Data final do formulário"
              localeText={{
                toolbarTitle: "Data final do formulário",
                cancelButtonLabel: "Cancelar",
              }}
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  fullWidth: true,
                  variant: "filled",
                },
              }}
            />
          </Grid>
          <Grid xs={6} md={6} lg={4} xl={4}>
            <AutoCompleteCustom
              onChange={(event: any) => {
                setFilter((prevState) => ({
                  ...prevState,
                  statusEstorno: event,
                }));
              }}
              title="Status do Estorno?"
              options={dataEstorno}
              clearDisabled={true}
              value={filter.statusEstorno}
              variant="filled"
              field="label"
              disabled={!!filter.numeroDoPedido || isLoading}
            />
          </Grid>
        </React.Fragment>
      )}
      <Grid xs={12} md={12} lg={12} xl={12}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
          height={"100%"}
        >
          <LoadingButton
            variant="contained"
            startIcon={<Search />}
            loadingPosition="start"
            onClick={filterApi}
            loading={isLoading}
          >
            Pesquisar
          </LoadingButton>
        </Stack>
      </Grid>
      {profileUser !== "FR" && profileUser !== "GECR" && (
        <Grid xs={12} md={12} lg={12} xl={12}>
          <ButtonCustom
            text="Importar"
            event={() => navigate("/uploadForms")}
          />
        </Grid>
      )}
      <Grid xs={12} md={12} lg={12} xl={12}>
        <TableComponent
          data={data}
          loading={isLoading}
          refresh={refresh}
          rowCountState={rowCountState}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
          gridApiRef={gridApiRef}
          handleExport={handleExport}
        />
      </Grid>
    </Grid>
  );
}

export default ReversalPage;
